<template>
  <span>
    <v-card class="mt-3">
      <v-card-title>
        <h5>Resumo Comparação BDGD x INDGER</h5>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-row class="mx-auto" justify="center" dense>
          <v-col cols="auto">
            Há
            <b
              :class="
                dadosComparacao.alimentadores.length > 0
                  ? 'error--text'
                  : 'success--text'
              "
            >
              {{
                dadosComparacao.alimentadores.length == null
                  ? "-"
                  : dadosComparacao.alimentadores.length
              }}
            </b>
            Alimentadores ausentes no INDGER em relação a BDGD
          </v-col>
        </v-row>
        <v-row class="mx-auto" justify="center" dense>
          <v-col cols="auto">
            Há
            <b
              :class="
                dadosComparacao.conj.length > 0
                  ? 'error--text'
                  : 'success--text'
              "
            >
              {{
                dadosComparacao.conj.length == null
                  ? "-"
                  : dadosComparacao.conj.length
              }}
            </b>
            Conjuntos ausentes no INDGER em relação a BDGD
          </v-col>
        </v-row>
        <v-row class="mx-auto" justify="center" dense>
          <v-col cols="auto">
            Há
            <b
              :class="
                dadosComparacao.sub.length > 0 ? 'error--text' : 'success--text'
              "
            >
              {{
                dadosComparacao.sub.length == null
                  ? "-"
                  : dadosComparacao.sub.length
              }}
            </b>
            Subestações ausentes no INDGER em relação a BDGD
          </v-col>
        </v-row>
        <v-row class="mx-auto mt-3" justify="center">
          <v-col cols="auto">
            Mais detalhes em:
            <router-link to="/paineis-gerenciais/dashboard-bdgd-indger">
              Painéis Gerenciais -> Dashboard BDGD x INDGER
            </router-link>
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col cols="1">
            <v-btn color="primary" @click.stop="dialogDetalhes = true">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <dialog-detalhes-comparacao-bdgd-indger
      v-model="dialogDetalhes"
      :dadosComparacao="dadosComparacao"
      @close="dialogDetalhes = false"
    />
  </span>
</template>

<script>
  import DashboardBdgdIndgerService from "@/services/DashboardBdgdIndgerService";

  export default {
    name: "CardResumoComparacaoBdgdIndger",
    components: {
      DialogDetalhesComparacaoBdgdIndger: () =>
        import(
          "@/components/dashboardGeral/Charts/DialogDetalhesComparacaoBdgdIndger.vue"
        ),
    },
    props: {
      competencia: {
        type: String,
        required: true,
      },
    },
    data: () => ({
      dadosComparacao: {
        alimentadores: [],
        sub: [],
        conj: [],
      },
      dataRegistroBdgd: null,
      dialogDetalhes: false,
    }),
    computed: {
      year() {
        return this.competencia.split("-")[0];
      },
    },
    mounted() {
      this.getDados();
    },
    methods: {
      async getDados(competencia = this.competencia) {
        this.dadosComparacao = {
          alimentadores: [],
          sub: [],
          conj: [],
        };

        try {
          const response = await Promise.all([
            this.getDadosComparacaoByEntidade("conj", competencia),
            this.getDadosComparacaoByEntidade("sub", competencia),
            this.getDadosComparacaoByEntidade("alimentadores", competencia),
          ]);
          this.dadosComparacao = response[0].data;
        } catch (error) {
          console.error("Erro ao buscar dados:", error);
        }
      },
      getDadosComparacaoByEntidade(entidade, competencia) {
        return DashboardBdgdIndgerService.getItensFaltantesByTipoAndEntidade(
          "bdgd",
          entidade,
          competencia,
          this.year
        )
          .then((res) => {
            this.dadosComparacao[entidade] = res;
          })
          .catch((err) => {
            throw err;
          });
      },
    },
    watch: {},
  };
</script>

<style></style>
